export interface Color {
  id: number;
  name: string;
}

export const colorTraslate: Record<string, string> = {
  white: 'Branca',
  black: 'Preta',
  red: 'Vermelha',
  blue: 'Azul',
  yellow: 'Amarelo',
  silver: 'Prata',
  beige: 'Bege',
  gray: 'Cinza',
  gold: 'Dourada',
  orange: 'Laranja',
  brown: 'Marrom',
  pink: 'Rosa',
  purple: 'Roxa',
  green: 'Verde',
};
